import { css, SerializedStyles } from '@emotion/react';
import { FieldChipVariant } from './FieldChipNode';

/** Shared pill shape for chips in the editor and their previews in the typeahead. */
export const chipShapeCss = css`
  border-radius: 4px;
  padding: 0.125rem 0.25rem;
`;

/**
 * The three chip looks on the secondary scale: a plain field (light), a list
 * (solid, dark) and a member of a list item (light with an outline), so the
 * scope of a ref is visible at a glance.
 */
export const CHIP_VARIANT_CSS: Record<FieldChipVariant, SerializedStyles> = {
  field: css`
    background: var(--mui-colors-secondary-10);
    color: var(--mui-colors-secondary-70);
  `,
  list: css`
    background: var(--mui-colors-secondary-70);
    /* The custom --mui-colors-* scale has no contrast-text entry; MUI's computed one (white on this purple) is the intended pick. */
    color: var(--mui-palette-secondary-contrastText);
  `,
  member: css`
    background: var(--mui-colors-secondary-5);
    color: var(--mui-colors-secondary-70);
    box-shadow: inset 0 0 0 1px var(--mui-colors-secondary-40);
  `,
};
